// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"624ff30e","184":"b60b8c22","321":"67425e1d","326":"b02f7f2d","428":"f71714e0","453":"1ea0f0cd","701":"5ab537a2","721":"e522df92","745":"565713ba","925":"ac509511","978":"b549d187"}[chunkId] + ".chunk.js";
};